import MenuComponent from '@/components/MenuComponent'
import MenuConnexion from '@/components/MenuConnexion'
import BlocAuthenticated from '@/components/BlocAuthenticated'
import hasPermission from '@/utils/utils.js'
import { UpdateUser } from '@/models/user.model'

export default {
  props: ['editedUser'],
  components: {
    MenuComponent,
    MenuConnexion,
    BlocAuthenticated
  },
  data () {
    return {
      isUserLocked: false,
      isXarmConfigNotInitialized: false,
      hasPermission,
      permissions: this.$store.state.user.user
        ? this.$store.state.user.user.permissions
        : [],
      otpGenerated: '',
      updateUserBean: new UpdateUser(),
      logsAdminAccess: false,
      adminRestricted: false
    }
  },
  mounted () {
    if (!this.editedUser) {
      this.$router.push({ name: 'administration/user/list' })
    } else if (this.editedUser) {
      if (!String.prototype.includes) {
        if (this.editedUser.rmUser && this.editedUser.rmUser.principals.indexOf('LogsAdmin', 0) !== -1) {
          this.logsAdminAccess = true
        }
      } else if (this.editedUser.rmUser && this.editedUser.rmUser.principals.includes('LogsAdmin')) {
        this.logsAdminAccess = true
      }

      this.checkIfUserLocked()
      this.checkIfXarmConfigNotInitialized()
    }
  },
  beforeCreate () {
    this.$store.state.filArianeMiddlePage = 'Liste des utilisateurs'
    this.$store.state.filArianePage = 'Détails de l\'utilisateur'
    this.$store.state.filArianeMiddleRouterLink = 'administration/user/list'
  },
  methods: {
    deleteUser () {
      this.updateUserBean.updateUser = this.$store.state.user.user.login
      this.updateUserBean.id = this.editedUser.personneId
      if (confirm('Voulez vous vraiment supprimer l\'utilisateur : ' + this.editedUser.firstName + ' ' + this.editedUser.lastName + ' ( id = ' + this.editedUser.login + ' ) ?')) {
        this.$store.dispatch('user/deleteUser', this.updateUserBean).then(
          () => {
            this.loading = false
            this.$router.push({ name: 'administration/user/list' })
          },
          error => {
            this.loading = false
            this.errorMessage = error.response.data
          }
        )
      }
    },
    format_date (value) {
      var moment = require('moment')
      if (value) {
        if (value === 'Invalid date') {
          return null
        } else {
          return moment(value).format('DD/MM/YYYY HH:mm:ss')
        }
      }
    },
    lockUser () {
      if (confirm('Voulez vous vraiment verrouiller l\'utilisateur : ' + this.editedUser.firstName + ' ' + this.editedUser.lastName + ' ( id = ' + this.editedUser.login + ' ) ?')) {
        this.$store.dispatch('user/lockUser', this.editedUser.login).then(
          () => {
            this.loading = false
            this.$store.dispatch('user/deleteUserList')
            this.$router.push({ name: 'administration/user/list' })
          },
          error => {
            this.loading = false
            this.errorMessage = error.response.data
          }
        )
      }
    },
    initXarmConf () {
      if (confirm('Initialisation configuration XARM pour l\'utilisateur : ' + this.editedUser.firstName + ' ' + this.editedUser.lastName + ' ( id = ' + this.editedUser.login + ' ) ?')) {
        this.$store.dispatch('user/initXarmConf', this.editedUser.login).then(
          () => {
            this.loading = false
            this.$router.push({ name: 'administration/user/list' })
          },
          error => {
            this.loading = false
            this.errorMessage = error.response.data
          }
        )
      }
    },
    deleteXarmConf () {
      if (confirm('Voulez vous vraiment supprimer la configuration XARM de l\'utilisateur : ' + this.editedUser.firstName + ' ' + this.editedUser.lastName + ' ( id = ' + this.editedUser.login + ' ) ?')) {
        this.$store.dispatch('user/deleteXarmConf', this.editedUser.login).then(
          () => {
            this.loading = false
            this.$router.push({ name: 'administration/user/list' })
          },
          error => {
            this.loading = false
            this.errorMessage = error.response.data
          }
        )
      }
    },
    resetPassword () {
      this.updateUserBean.login = this.editedUser.login
      this.updateUserBean.updateUser = this.$store.state.user.user.login
      if (confirm('Voulez vous vraiment réinitialiser le code personnel de : ' + this.editedUser.firstName + ' ' + this.editedUser.lastName + ' ( id = ' + this.updateUserBean.login + ' ) ?')) {
        this.$store.dispatch('user/resetPassword', this.updateUserBean).then(
          response => {
            this.otpGenerated = response
            this.$router.push({ name: 'administration/user/view', params: { 'editedUser': this.$store.editedUser } })
          },
          error => {
            this.errorMessage = error.response.data
          }
        )
      }
    },
    checkIfUserLocked () {
      this.$store.dispatch('user/checkIfUserLocked', this.editedUser.login).then(
        responseChecking => {
          this.isUserLocked = responseChecking
        },
        error => {
          this.errorMessage = error.response.data
        }
      )
    },
    checkIfXarmConfigNotInitialized () {
      this.$store.dispatch('user/checkIfXarmConfigNotInitialized', this.editedUser.login).then(
        responseChecking => {
          this.isXarmConfigNotInitialized = responseChecking
        },
        error => {
          this.errorMessage = error.response.data
        }
      )
    }
  }
}
